import { createFileRoute } from "@tanstack/react-router";
import siteConfig from "~/site.config";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/community")(
  {
    component: CommunityComponent,
    beforeLoad: () => ({
      title: `${siteConfig.siteTitle} - Community`,
      headerTitle: "Community",
      headerDescription: "Connect with other creators.",
    }),
  },
);

function CommunityComponent() {
  return (
    <div className="h-full w-full p-8">
      <div className="flex justify-center">
        <iframe
          style={{
            border: 0,
            boxShadow: "none",
            width: "100%",
            height: "150vh",
          }}
          src="https://creatorgrid-75b30f.circle.so"
          title="UGC Accelerator Community"
        />
      </div>
    </div>
  );
}
